import type { GroupColor } from '../../types';

export interface GroupColorStyle {
  dot: string;
  badge: string;
  activeBg: string;
  activeText: string;
}

export const GROUP_COLORS: Record<GroupColor, GroupColorStyle> = {
  primary: {
    dot: 'bg-primary-500',
    badge: 'bg-primary-100 text-primary-700',
    activeBg: 'bg-primary-100',
    activeText: 'text-primary-800',
  },
  accent: {
    dot: 'bg-accent-500',
    badge: 'bg-accent-100 text-accent-700',
    activeBg: 'bg-accent-100',
    activeText: 'text-accent-800',
  },
  secondary: {
    dot: 'bg-secondary-500',
    badge: 'bg-secondary-100 text-secondary-700',
    activeBg: 'bg-secondary-100',
    activeText: 'text-secondary-800',
  },
  neutral: {
    dot: 'bg-foreground-400',
    badge: 'bg-foreground-100 text-foreground-700',
    activeBg: 'bg-foreground-200',
    activeText: 'text-foreground-800',
  },
};

export const GROUP_COLOR_KEYS = Object.keys(GROUP_COLORS) as GroupColor[];